import { convertToExportedView } from '@estee/elc-service';
import { PRODUCT_REVIEWS } from '@estee/elc-service-view-names';
import { IProductReviews } from './ProductReviews';
import serviceNames from '~setup/RatingsReviewsService';

/*eslint no-restricted-syntax: ["off"]*/
export default convertToExportedView<IProductReviews>(
    () => import('./ProductReviews'),
    PRODUCT_REVIEWS,
    serviceNames.productReviewsViewController
);
